/// <amd-module name="Feed/Legacy/Protocols/Maven/MavenClientTool" />
import * as React from "react";

import { IVssPageContext } from "VSS/Platform/Context";

import { FeedView } from "Feed/Common/Contracts/Feed";
import { IPackageProtocolClient } from "Feed/Legacy/Protocols/Common/IPackageProtocol";
import { IMavenConnectToFeedPanelProps, MavenConnectToFeedPanel } from "Feed/Legacy/Protocols/Maven/MavenConnectToFeedPanel";
import { HubAction } from "Feed/Legacy/Types/IHubState";
import { Feed } from "Feed/Legacy/WebApi/VSS.CustomFeed.Contracts";

export class MavenClientTool implements IPackageProtocolClient {
    public readonly name = "Maven";

    private pageContext: IVssPageContext;

    constructor(pageContext: IVssPageContext) {
        this.pageContext = pageContext;
    }

    public getConnectPanel(feed: Feed, feedViews: FeedView[], hubAction: HubAction): JSX.Element {
        return React.createElement(MavenConnectToFeedPanel, {
            pageContext: this.pageContext,
            feed,
            feedViews,
            hubAction
        } as IMavenConnectToFeedPanelProps);
    }
}
